export function handleDecimals(number, decimals = 0, action = 'prepare') {
    if (parseInt(decimals) === 0) {
        return parseInt(number, 10);
    }

    if (decimals < 0) {
        console.warn(
            `CT Counter number formatting error: decimals should be declared positive, instead ${decimals} was provided. This value will be converted using Math.abs().`
        );

        decimals = Math.abs(decimals);
    }

    if (action === 'prepare') {
        return Math.round(parseFloat(number) * decimals * 10);
    } else if (action === 'return') {
        return parseFloat(number / (decimals * 10));
    }
}

export function localizeNumber(number, locale = 'de-ch') {
    return number.toLocaleString(locale);
}
